<div class="chart">
  <canvas
    baseChart
    [data]="doughnutData"
    [options]="doughnutOptions"
    [type]="'doughnut'"
  ></canvas>

  @if (featureValue !== undefined) {
  <div class="text">
    <div class="percentage">{{ featureValue || 0 }}</div>
    <div class="correct">
      {{ featureLabel || 'chart.label.correct' | translate }}
    </div>
  </div>
  }
</div>
@if (!showProgressBar) {
<div class="legend">
  <div class="flex-column">
    @for (section of sections; track section.label) {
    <div
      class="line"
      [class.clickable]="section.click"
      (click)="section.click ? section.click() : null"
    >
      <div
        class="dot"
        [style.backgroundColor]="section?.color || color(section)"
      ></div>
      <span>{{ section.label }}</span>
    </div>
    }
  </div>
</div>
} @else {
<div class="results-container">
  @for (section of sections; track section.label) {
  <div
    class="result-card"
    [style.borderColor]="section?.color || color(section)"
    [style.backgroundColor]="(section?.color || color(section)) + '10'"
    [class.clickable]="section.click"
    (click)="section.click ? section.click() : null"
  >
    <div class="result-value" [style.color]="section?.color || color(section)">
      {{ section.value }}
    </div>
    <div class="result-label">
      {{ section.shortLabel }}
    </div>
    <div class="progress-bar-container">
      <div
        class="progress-bar"
        [style.width.%]="calculatePercentage(section)"
        [style.backgroundColor]="section?.color || color(section)"
      ></div>
    </div>
    @if(section.click){<mat-icon class="person-icon">person_add</mat-icon>}
  </div>
  }
</div>
}
